import { render, staticRenderFns } from "./StandardBox.vue?vue&type=template&id=0552d6de&scoped=true&"
import script from "./StandardBox.vue?vue&type=script&lang=js&"
export * from "./StandardBox.vue?vue&type=script&lang=js&"
import style0 from "./StandardBox.vue?vue&type=style&index=0&id=0552d6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552d6de",
  null
  
)

export default component.exports